import ContainerBlockGenericType from "../ContainersBlocks/ContainerBlockGenericType";

function FEDGE
    ({ id, isConnectable, type, selected }) {
    return (
        <ContainerBlockGenericType
            id={id}
            isConnectable={isConnectable}
            type={type}
            selected={selected}
            flagNumber={42}
            adderFlag={22}
            showLabelInput={true}
            userConfiguration={true}
        />
    );
}
export default FEDGE